import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9951205c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["onClick"]

import { UsuarioDTO } from "@/interfaces/Usuario";
import { onMounted, ref, computed, watch } from "vue";
import { useRouter } from "vue-router";
import LoadingGandalf from "../Commons/LoadingGandalf.vue";
import defaultAvatar from "@/assets/icons/perfil.png";
import debounce from "lodash/debounce";


export default /*#__PURE__*/_defineComponent({
  __name: 'TablaUsuarios',
  props: {
  usuarios: {
    type: Array as () => UsuarioDTO[],
    required: true,
  },
},
  setup(__props) {

const props = __props;

const search = ref<string>("");
const debouncedSearch = ref<string>("");
const items = ref<UsuarioDTO[]>([]);
const isLoading = ref<boolean>(true);
const router = useRouter();
const selectedProvince = ref<string | null>(null);
const selectedFaction = ref<string | null>(null);

const headers = [
  { title: "Nick", key: "nick", align: "start" },
  { title: "Facción", key: "faccion" },
  { title: "Ciudad", key: "ciudad" },
];

const provinces = computed(() => [
  ...new Set(items.value.map((user) => user.ciudad).filter(Boolean)),
]);

const factions = computed(() => [
  ...new Set(
    items.value.map((user) => user.faccion?.nombreFaccion).filter(Boolean)
  ),
]);

watch(
  search,
  debounce((newValue: string) => {
    debouncedSearch.value = newValue;
  }, 300)
);

const filteredItems = computed(() => {
  return items.value.filter((user) => {
    return (
      (!selectedProvince.value || user.ciudad === selectedProvince.value) &&
      (!selectedFaction.value ||
        user.faccion?.nombreFaccion?.toLowerCase() ===
          selectedFaction.value.toLowerCase()) &&
      (debouncedSearch.value === "" ||
        user.nick.toLowerCase().includes(debouncedSearch.value.toLowerCase()))
    );
  });
});

const goToUserDetail = (idUsuario: number) => {
  router.push({ name: "detalle-jugador", params: { idUsuario } });
};

onMounted(() => {
  isLoading.value = true;
  try {
    items.value = [...props.usuarios].sort((a, b) =>
      a.nick.localeCompare(b.nick)
    );
  } catch (error) {
    console.error("Error al obtener la clasificación de Elo:", error);
  } finally {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(LoadingGandalf)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_v_card, { flat: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex align-center pe-2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "me-2",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-account-group")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Usuarios ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: search.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                          density: "compact",
                          label: "Buscar usuario",
                          "prepend-inner-icon": "mdi-magnify",
                          variant: "solo-filled",
                          flat: "",
                          "hide-details": "",
                          "single-line": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: selectedFaction.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedFaction).value = $event)),
                          items: factions.value,
                          label: "Filtrar por facción",
                          clearable: ""
                        }, null, 8, ["modelValue", "items"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: selectedProvince.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedProvince).value = $event)),
                          items: provinces.value,
                          label: "Filtrar por provincia",
                          clearable: ""
                        }, null, 8, ["modelValue", "items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_data_table, {
              items: filteredItems.value,
              loading: isLoading.value,
              headers: headers,
              class: "custom-table",
              "item-key": "nick"
            }, {
              item: _withCtx(({ item }) => [
                _createElementVNode("tr", {
                  onClick: ($event: any) => (goToUserDetail(item.idUsuario)),
                  class: "clickable-row"
                }, [
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_avatar, {
                      size: "32",
                      class: "me-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_img, {
                          src: item.avatar || _unref(defaultAvatar),
                          alt: "Avatar"
                        }, null, 8, ["src"])
                      ]),
                      _: 2
                    }, 1024),
                    _createTextVNode(" " + _toDisplayString(item.nick), 1)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.faccion?.nombreFaccion || "N/A"), 1),
                  _createElementVNode("td", null, _toDisplayString(item.ciudad || "N/A"), 1)
                ], 8, _hoisted_3)
              ]),
              _: 1
            }, 8, ["items", "loading"])
          ]),
          _: 1
        })
      ]))
}
}

})